"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const immutable_1 = require("immutable");
const react_router_1 = require("react-router");
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const mui_1 = require("tss-react/mui");
const Dialog_1 = __importDefault(require("@mui/material/Dialog/Dialog"));
const MonthlyCalendar_1 = __importDefault(require("./MonthlyCalendar"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.transactionCalendarStyles);
const TransactionCalendar = (props) => {
    var _a, _b;
    const { classes } = useStyles();
    const { inDialog = false, year, month, setDate, navFn, onClose } = props;
    const { datasetPreferences } = (0, useQPreferences_1.default)();
    const { accountsToShow } = datasetPreferences.calendarTransaction;
    const location = (0, react_router_1.useLocation)();
    const accountIds = ((_a = location.search) === null || _a === void 0 ? void 0 : _a.includes('displayNode=all')) ?
        (accountsToShow || (0, immutable_1.Set)()) :
        (_b = props.accountIds) !== null && _b !== void 0 ? _b : (0, immutable_1.Set)();
    const setCalendarDate = (0, react_1.useCallback)((yearValue, monthValue) => {
        if (setDate) {
            setDate(yearValue, monthValue);
        }
    }, [setDate]);
    const closeAndExit = (0, react_1.useCallback)(() => onClose && onClose(), [onClose]);
    const cachedNavFn = (0, react_1.useCallback)((txn) => { navFn(txn); closeAndExit(); }, [navFn, closeAndExit]);
    const MonthCalendar = (<MonthlyCalendar_1.default onClose={closeAndExit} accountIds={accountIds} navFn={cachedNavFn} month={month} year={year} setDate={setCalendarDate} showCloseButton={inDialog}/>);
    if (inDialog) {
        return (<Dialog_1.default classes={{ paper: classes.container }} open maxWidth="xl">    
        {MonthCalendar}
      </Dialog_1.default>);
    }
    return (<div className={classes.fullScreen}>
      {MonthCalendar}
    </div>);
};
exports.default = TransactionCalendar;
